export default "__VITE_ASSET__606c8236__"